import { get, post } from './client';
import type {
  AdminSubscriptionListResponse,
  AdminSubscription,
  ListAdminSubscriptionsParams,
} from '@/types/admin-subscription';

export async function listAdminSubscriptions(
  params?: ListAdminSubscriptionsParams
): Promise<AdminSubscriptionListResponse> {
  const queryParams: Record<string, string> = {};
  if (params?.merchantId) queryParams.merchantId = params.merchantId;
  // serviceId filter: works in local mode, silently dropped by Facade
  if (params?.serviceId) queryParams.serviceId = params.serviceId;
  if (params?.status) queryParams.subscriptionStatus = params.status;
  if (params?.limit) queryParams.limit = String(params.limit);
  if (params?.cursor) queryParams.cursor = params.cursor;
  return get<AdminSubscriptionListResponse>('/admin/subscriptions', queryParams);
}

export async function getAdminSubscription(
  subscriptionId: string
): Promise<AdminSubscription> {
  return get<AdminSubscription>(`/admin/subscriptions/${encodeURIComponent(subscriptionId)}`);
}

export async function terminateSubscription(
  subscriptionId: string,
  reason?: string
): Promise<AdminSubscription> {
  return post<AdminSubscription>(
    `/admin/subscriptions/${encodeURIComponent(subscriptionId)}/terminate`,
    reason ? { reason } : undefined
  );
}
